module.exports = __webpack_public_path__ + "static/media/auth.4030ef0a.png";